function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import loadId from "./shared/loadId";
export default function logHttp(type, observabilityFns, params) {
    const { analytics, errors, metrics } = observabilityFns || {};
    // TODO(mjimenez): SDK-PARAMS (remove)
    const page = '<unknown>'; // This should be `useRoute()[0].name`.
    const analyticsParams = _object_spread_props(_object_spread({}, params), {
        networkLoadId: loadId
    });
    const metricTags = {
        service: analyticsParams.service,
        project: analyticsParams.project,
        component: analyticsParams.component,
        // TODO(mjimenez): SDK-PARAMS (remove)
        page,
        // TODO(mjimenez): SDK-PARAMS (remove)
        owner: analyticsParams.project,
        error_expected: analyticsParams.errorExpected,
        error_muted: analyticsParams.errorMuted,
        error_source: analyticsParams.errorSource,
        operation_name: analyticsParams.operationName,
        operation_tag: analyticsParams.operationTag,
        operation_deduplicate: analyticsParams.operationDeduplicate,
        operation_prefetch: analyticsParams.operationPrefetch,
        operation_prefetch_hit: analyticsParams.operationPrefetchHit
    };
    // Report to Splunk and SFX.
    metrics === null || metrics === void 0 ? void 0 : metrics.increment('frontend.data.error', metricTags);
    analytics === null || analytics === void 0 ? void 0 : analytics.track('frontend.data.error', analyticsParams);
    // Report to Sentry.
    if (!analyticsParams.errorExpected && !analyticsParams.operationPrefetch) {
        const project = analyticsParams.project;
        const muted = analyticsParams.errorMuted;
        const errorMessage = `${type} error '${analyticsParams.errorCode}' on operation '${analyticsParams.operationName}'`;
        const method = muted ? errors.warning : errors.error;
        if (project !== '<unknown>') {
            const errorReportExtras = _object_spread_props(_object_spread({}, analyticsParams), {
                page
            });
            method(errorMessage, {
                project,
                extras: errorReportExtras
            });
        }
    }
}

//# sourceMappingURL=logHttp.js.map